/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.29.35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const JackpotStatus = {
    _11184809: '11184809',
    PENDING: 'PENDING',
    ACTIVE: 'ACTIVE',
    NO_JACKPOT: 'NO_JACKPOT',
    unknown_default_open_api: '11184809'
} as const;
export type JackpotStatus = typeof JackpotStatus[keyof typeof JackpotStatus];


export function instanceOfJackpotStatus(value: any): boolean {
    for (const key in JackpotStatus) {
        if (Object.prototype.hasOwnProperty.call(JackpotStatus, key)) {
            if (JackpotStatus[key as keyof typeof JackpotStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function JackpotStatusFromJSON(json: any): JackpotStatus {
    return JackpotStatusFromJSONTyped(json, false);
}

export function JackpotStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): JackpotStatus {
    return json as JackpotStatus;
}

export function JackpotStatusToJSON(value?: JackpotStatus | null): any {
    return value as any;
}

